import { useTranslation } from 'react-i18next'
import TextComponent from '../TextComponent/TextComponent'
import styles from './LanguageSwitch.module.scss'

interface LanguageSwitchProps {
  dark?: boolean
}

function LanguageSwitch({ dark }: LanguageSwitchProps) {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  const handleLanguageChange = (lang: string | undefined) => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
  }

  return (
    <div className={`${styles.languageSwitch}`}>
      <TextComponent
        text="Pl"
        fontSize="body-bold-medium"
        color={currentLanguage === 'pl' ? 'secondary' : 'primary'}
        uppercase
        onclick={() => handleLanguageChange('pl')}
        dark={dark}
      />
      <TextComponent
        text="En"
        fontSize="body-bold-medium"
        color={currentLanguage === 'en' ? 'secondary' : 'primary'}
        uppercase
        onclick={() => handleLanguageChange('en')}
        dark={dark}
      />
    </div>
  )
}

export default LanguageSwitch
